import React from "react";
import { resolveRichText } from "../../../utils/richText";
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage";
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper";
import "./metricCallout.scss"
const metricCallout = ( {blok} ) => {
    var layout;
    var layoutClass = "inline"
    var position = {
        text: "",
        metric: "",
    };
    if(blok.full_width){
        layoutClass="full-width"
        layout = {
            text: "col-sm-12",
            metric: "col-sm-12",
        };
    }else{
        layout = {
            text: "col-sm-8",
            metric: "col-sm-4"
        }
    }

    // console.log(blok.position);
    if(blok.position === "left"){
        position.text = "col-sm-push-4";
        position.metric = "col-sm-pull-8";
    }
    // console.log(position);

    var mainText = resolveRichText(blok.text);
    var metricText = resolveRichText(blok.metric_text);

    return ( 
        <WidgetWrapper blok={blok}>
            <div className={`metric-callout row ${layoutClass}`}>
                <div className={`${layout.text} ${blok.position === "left" && !blok.full_width ? "textPosLeft": ""}`}>
                    <div dangerouslySetInnerHTML={mainText}></div>
                </div>
                <div className={`${layout.metric} ${blok.position === "left" && !blok.full_width ? "metricPosLeft": ""}`}>
                    <div className={`metric-container ${blok.widget_theme}`}>
                    {blok.metric ? <h4>{blok.metric}</h4> : null}
                    {blok.metric ? <hr/>: null}
                    <div className="metric-content">
                    {blok.image && blok.image.filename !== "" ? <StoryblokImage sbImageData={blok.image} width={55} height={55}/>: null}
                    {blok.metric_text? <div className={blok.image && blok.image.filename && !blok.full_width ? 'sm-text': ""} dangerouslySetInnerHTML={metricText}></div> : null}
                    </div>
                    {blok.source ? <span className="metric-source">Source: {blok.source}</span>: null}
                    </div>
                </div>
            </div>
        </WidgetWrapper>
     );
}
 
export default metricCallout;